import React from "react";

function About() {
  return (
    <div className="about-page">
      <div className="page-header">
        <h1>About Samsung Door-Step</h1>
        <p>
          Your trusted partner for authentic Samsung products delivered to your
          doorstep
        </p>
      </div>

      <div className="container">
        <section className="about-intro">
          <h2>Who We Are</h2>
          <p>
            Samsung Door-Step brings genuine Samsung products to your doorstep
            with ease. Simply place your order on our website, and we’ll take
            care of delivering your favorite Samsung electronics right to your
            home.
          </p>
          <p>
            We pride ourselves on offering 100% authentic products, competitive
            pricing, and exceptional customer service. Every product comes with
            a manufacturer's warranty and full after-sales support.
          </p>
        </section>

        <section className="mission-vision">
          <div className="mission-box">
            <h3>Our Mission</h3>
            <p>
              To provide every Pakistani household with access to genuine
              Samsung products at affordable prices with reliable and fast
              doorstep delivery.
            </p>
          </div>
          <div className="vision-box">
            <h3>Our Vision</h3>
            <p>
              To become the leading authorized Samsung distributor in Pakistan
              by offering an unmatched shopping experience and customer
              satisfaction.
            </p>
          </div>
        </section>

        <section className="timeline">
          <h2>Our Journey</h2>
          <div className="timeline-items">
            <div className="timeline-item">
              <div className="timeline-year">2020</div>
              <p>Samsung Door-Step founded with focus on convenience</p>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">2021</div>
              <p>Established strong presence in Lahore</p>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">2022</div>
              <p>Launched same-day delivery service</p>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">2023</div>
              <p>Reached 100,000+ satisfied customers</p>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">2024</div>
              <p>Became #1 Samsung authorized distributor</p>
            </div>
          </div>
        </section>

        <section className="team-values">
          <h2>Our Core Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <h3>Authenticity</h3>
              <p>100% genuine Samsung products only</p>
            </div>
            <div className="value-card">
              <h3>Reliability</h3>
              <p>On-time delivery, every time</p>
            </div>
            <div className="value-card">
              <h3>Integrity</h3>
              <p>Transparent pricing and honest dealings</p>
            </div>
            <div className="value-card">
              <h3>Customer Focus</h3>
              <p>Your satisfaction is our priority</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default About;
